// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelForm-Content_cls1__gobuY","cls2":"PaymentChannelForm-Content_cls2__FND5y PaymentChannelForm-Content_cls1__gobuY"};